import { AxiosPromise } from "axios";

export const emptySubmitChangeFunc = (): AxiosPromise<server.dto.ApiResponse> => {
  return new Promise(resolve => {
    resolve({
      data: {
        errors: [],
        hasErrors: false,
      },
      status: 200,
      statusText: "OK",
      headers: undefined,
      config: undefined,
      request: undefined,
    });
  });
}

export const emptyListFunc = (): AxiosPromise<server.dto.ApiResponseWrapper<any>> => {
  return new Promise(resolve => {
    resolve({
      data: {
        data: [],
        errors: [],
        hasErrors: false,
        pagination: {
          page: 1,
          perPage: 20,
          pageCount: 0,
          hasResults: false,
          maxPerPage: 20,
          total: 0,
        },
      },
      status: 200,
      statusText: "OK",
      headers: undefined,
      config: undefined,
      request: undefined,
    });
  });
}

export const emptySubmitChangeFuncWithError = (errorMsg: string): AxiosPromise<server.dto.ApiResponse> => {
  return new Promise(resolve => {
    resolve({
      data: {
        errors: [{
          message: errorMsg,
          code: "unknown",
          target: ""
        }],
        hasErrors: true,
      },
      status: 200,
      statusText: "OK",
      headers: undefined,
      config: undefined,
      request: undefined,
    });
  });
}